/* eslint-disable @typescript-eslint/no-this-alias */
import React, { useState, useEffect } from 'react';
import Skeleton from '@mui/material/Skeleton';
import BillingAddressCardSelect from './BillingAddressCardSelect.jsx';
import Button from '../../buttons/Button.jsx';
import TooltipSimple from '../../tooltips/TooltipSimple.jsx';
import { useTranslation } from 'react-i18next';

const BillingAddressSelectContainer = (props) => {
    const {
        from,
        connected_as,
        membres_id,
        requests_hotels_id,
        defaultValue
    } = props;

    const { t: gctrad } = useTranslation();

    const [billingAddresses, setBillingAddresses] = useState([]);
    const [addressSelected, setAddressSelected] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        let ajax_url = ENV.base_lang_url+"myspace/" + connected_as + "//ajaxGetter/get_billing_addresses_by_membres";
        
        const params = new URLSearchParams();
        if(requests_hotels_id > 0) {
            params.append('requests_hotels_id', requests_hotels_id);
        }
        if(membres_id > 0) {
            params.append('membres_id', membres_id);
        }

        fetch(ajax_url, { 
            method: 'POST',
            headers:  { "Content-Type": "application/x-www-form-urlencoded" },
            body: params.toString()
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setBillingAddresses(result.billingAddresses);
                    setIsLoading(false);
                }
            );
    }, [])

    useEffect(() => {
        // On enlève l'attribut disabled du bouton permettant de confirmer la résa
        let btn = $('.btn-submit-confirm-reservation:disabled');
        if(btn.length > 0 && addressSelected != null) {
            btn.removeAttr('disabled');
        }

        if (defaultValue > 0 && addressSelected == null) {
            setSelected(defaultValue)
        }       
    }, [addressSelected])

    useEffect(() => {
        // On regarde si une adresse est déjà sélectionnée 
        for ( let i in billingAddresses ) {
            if ( billingAddresses[i].selected ) setAddressSelected(billingAddresses[i].id);
        }
    }, [billingAddresses])

    const setSelected = id => {
        setAddressSelected(id)
    }


    const cardRow = (
        <>
            {billingAddresses.length > 0 ?
                billingAddresses.map((e, index) =>
                <BillingAddressCardSelect
                    id={e.id}
                    key={index}
                    cardTitle={e.name}
                    businessName={e.business_name}
                    lastName={e.business_holder_last_name}
                    firstName={e.business_holder_first_name}
                    address={e.business_address}
                    postalCode={e.business_postal_code}
                    city={e.business_city}
                    country={e.title}
                    taxId={e.business_tax_id}
                    isDefault={e.is_default}
                    isSelected={(e.id == addressSelected) ? 1 : 0}
                    onDefineAsSelected={setSelected}
                    editable={e.editable ?? true}
                    requestsHotelsId={requests_hotels_id}
                    connectedAs={connected_as}
                />)
                :
                <div className="col-12 col-md-6 mb-3">
                    <a
                        href="#"
                        data-target={connected_as+"//account/billing_address_add/" + membres_id}
                        data-part="+"
                        className="billing-address-card bg-light border border-light rounded d-flex align-items-center justify-content-around get_part_link js-nav"
                        style={{width: '100%', height: '360px'}}
                    >
                        <span className="text-gc-orange font-weight-bold">
                            <i className="fas fa-plus mr-1"></i>
                            {gctrad('Ajouter une adresse')}
                        </span>
                    </a>
                </div>
            }

            
        </>
    );

    const hiddenId = (
        <input
            type="hidden"
            name="payment_informations_id" 
            value={addressSelected ?? ''}
        />
    )

    const rowSkeleton = (

        <div className="billing-address-card col-12 col-md-6 mb-3">
            <Skeleton className="card" variant="rectangular" width="100%" height={360} />
        </div>
    )

    return (from == 'confirm_reservation' ?
        <div className="row">
            {isLoading ? rowSkeleton :
            <>
                {cardRow}
            </>}
            {hiddenId}
        </div>
        :
        <form method="POST" action="">
        {isLoading ? rowSkeleton :
            <> 
                <div className="row">
                    {cardRow}
                    <div className="col-12 mt-2">
                        <div className="col-12 col-md-6 mx-auto">
                            <TooltipSimple
                                title={addressSelected == null ? gctrad('Selectionnez une adresse de facturation') : null}
                            >
                                <span>
                                    <Button
                                        text={gctrad('Enregistrer')} 
                                        color={'orange'} 
                                        size={'large'}
                                        width={'100'}
                                        type={'submit'}
                                        disabled={addressSelected == null ? true : false}
                                    />                                     
                                </span>
                            </TooltipSimple>
                            
                        </div>
                    </div>
                </div>  
            </>}
            {hiddenId} 
        </form>
    )
}

export default BillingAddressSelectContainer;

BillingAddressSelectContainer.defaultProps = {
    defaultValue: null,
    membres_id: 0,
    requests_hotels_id: 0,
    connected_as: 'providers'
};